import { Stack, usePathname } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";

export default function ResidentsLayout() {
  const pathName = usePathname();
  const screenName = pathName.includes("add")
    ? "Add new resident"
    : "Residents";

  return (
    <PageLayout
      screenName={screenName}
      className="py-dashboard"
      titleClassName="text-primary-800"
      headerClassName="mx-dashboard"
    >
      <Stack
        screenOptions={{
          headerShown: false,
        }}
      />
    </PageLayout>
  );
}
